import Model from '../../ModelBinding/Model';
import MissionEventCollection from './MissionEventCollection';
import dayjs from 'dayjs';
import Member from '../Member/Member';
import ReasonCollection from '../Reason/ReasonCollection';

export default class MissionEvent extends Model {
  public created_by?: Member;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public expires_at?: dayjs.Dayjs;
  public blocking?: boolean;
  public code?: string;
  public name?: string;
  public description?: string;
  public payload?: string;
  public reasons?: ReasonCollection;
  public blocker_id?: string;
  public blocked_at?: dayjs.Dayjs;
  public blocked_by?: Member;
  public unblocked_at?: dayjs.Dayjs;

  bind() {
    this.code = this.getStringAttribute('code');
    this.name = this.getStringAttribute('name');
    this.description = this.getStringAttribute('description');
    this.blocking = this.getBooleanAttribute('blocking');
    this.created_by = this.getRelationAttribute('created_by', Member) as Member;
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.expires_at = this.getDateAttribute('expires_at');
    this.payload = this.getStringAttribute('payload');
    this.reasons = this.getRelationCollection('reasons', ReasonCollection) as ReasonCollection;
    this.blocker_id = this.getStringAttribute('blocker_id');
    this.blocked_at = this.getDateAttribute('blocked_at');
    this.blocked_by = this.getRelationAttribute('blocked_by', Member) as Member;
    this.unblocked_at = this.getDateAttribute('unblocked_at');
  }

  static getCollection() {
    return MissionEventCollection;
  }
}
